// removed by extract-text-webpack-plugin
module.exports = {"blackWeekend":"qempo_BlackWeekendBanner_blackWeekend-2QcloTF","content":"qempo_BlackWeekendBanner_content-KRYKAFe","text":"qempo_BlackWeekendBanner_text-2qFazdc","timeWrap":"qempo_BlackWeekendBanner_timeWrap-2fyOn_h","unitWrap":"qempo_BlackWeekendBanner_unitWrap-bRbEN5y","fromMobile":"qempo_BlackWeekendBanner_fromMobile-36ZNk9q","number":"qempo_BlackWeekendBanner_number-KzJ_SOQ"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/components/BlackWeekendBanner/BlackWeekendBanner.scss
// module id = 1493
// module chunks = 0